import { mix } from "@chorda/core";
export const Text = (props) => {
    return mix((props === null || props === void 0 ? void 0 : props.as) || { tag: 'span' }, {
    //        tag: 'span',
    }, props && {
        css: props.css,
        defaults: {
            text: () => props.text
        },
        injections: {
            text: props.text$
        },
        events: {
            $dom: {
                click: props.onClick
            }
        },
        reactions: {
            text: (v) => {
                return ({ text: (props.format || String)(v) });
            }
        },
    });
};
